import { lifiLogoUrl } from '../icons.js';
export const defaultBaseAccountConfig = {
    appName: 'LI.FI',
    appLogoUrl: lifiLogoUrl,
};
//# sourceMappingURL=baseAccount.js.map